<template>
  <b-container class="mx-0 px-0">
    <b-container class="d-flex flex-column align-items-start p-0">
      <slot name="header"> </slot>
    </b-container>

    <b-container class="grid__cards p-0">
      <router-link
        v-for="(item, index) in items"
        :key="`${item.id}-${index}`"
        :to="{
          name: 'stack-detail',
          params: { stackId: item.id }
        }"
        class="stack-card-list__item"
      >
        <StackCard :item="item" />
      </router-link>
    </b-container>
  </b-container>
</template>
<script>
import StackCard from '@/views/Stack/components/StackCard.vue';
export default {
  components: {
    StackCard
  },
  props: {
    items: {
      type: Array,
      default: () => []
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep .stack__thumbnail-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
}
.stack__thumbnail-header {
  position: relative;
  aspect-ratio: 1.69; // fixed aspect ratio
  // overflow: hidden;
}
.grid__cards {
  display: grid;
  grid-template-columns: repeat(3, minmax(352px, 1fr));
  gap: 2.5rem;
  justify-content: center;
}

/* Large devices (desktops, 992px and up) */
@media screen and (max-width: 1199px) {
  .grid__cards {
    grid-template-columns: repeat(3, minmax(282px, 1fr));
  }
}

/* Medium devices (tablets, 768px to 991px) */
@media screen and (max-width: 991px) {
  .grid__cards {
    grid-template-columns: repeat(2, minmax(332px, 1fr));
  }
}

/* Extra small devices (portrait phones, less than 576px) */
@media screen and(max-width: 767px) {
  .grid__cards {
    grid-template-columns: repeat(2, minmax(264px, 1fr));
    gap: 1rem;
  }
}
@media screen and (max-width: 575px) {
  .grid__cards {
    grid-template-columns: repeat(2, minmax(163px, 1fr));
    gap: 1rem;
  }
}
@media screen and (max-width: 374px) {
  .grid__cards {
    grid-template-columns: repeat(2, minmax(130px, 1fr));
    gap: 1rem;
  }
}
</style>
